/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_content_delivery_bucket": "ohti-projection-transform-front-dev",
    "aws_content_delivery_bucket_region": "ap-northeast-1",
    "aws_content_delivery_url": "https://d2vhdufugnmgi0.cloudfront.net",
    "aws_cognito_identity_pool_id": "ap-northeast-1:438853a3-5053-46fa-9ed9-1faae9910a3a",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_aDzbn1iXa",
    "aws_user_pools_web_client_id": "461li435geljka6d5h87hv83bd",
    "oauth": {},
    "aws_user_files_s3_bucket": "ohti-projection-tranform-work-dev155417-dev",
    "aws_user_files_s3_bucket_region": "ap-northeast-1",
    "aws_cloud_logic_custom": [
        {
            "name": "apiopts",
            "endpoint": "https://s1x5f2ioa3.execute-api.ap-northeast-1.amazonaws.com/dev",
            "region": "ap-northeast-1"
        }
    ]
};


export default awsmobile;
